import { combineReducers } from 'redux';
import home from './home';
import artist from './artist';
import profile from './profile';
import artistAlbums from './artistAlbums';
import artistRelated from './artistRelated';
import artistAppearsOn from './artistAppearsOn';
import album from './album';
import track from './track';
import playlist from './playlist';
import library from './library';
import search from './search';
import player from './player';
import userProfile from './userProfile';

const rootReducer = combineReducers({
  profile,
  home,
  artist,
  artistAlbums,
  artistRelated,
  artistAppearsOn,
  album,
  track,
  playlist,
  library,
  search,
  player,
  userProfile,
});

export default rootReducer;
